var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "teams-chat_svg__a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.59 15.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams-chat_svg__c",
    x1: 533.24,
    y1: -599.68,
    x2: 576.92,
    y2: -599.68,
    gradientTransform: "translate(-34.4 -36.81) scale(.07 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams-chat_svg__d",
    x1: 598.02,
    y1: -599.68,
    x2: 641.69,
    y2: -599.68,
    gradientTransform: "translate(-34.4 -36.81) scale(.07 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teams-chat_svg__e",
    x1: 659.95,
    y1: -599.68,
    x2: 703.63,
    y2: -599.68,
    gradientTransform: "translate(-34.4 -36.81) scale(.07 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "teams-chat_svg__b",
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.89,15.58c-.49,0-.89-.4-.89-.89v-7.74C0,3.11,3.12,0,6.95,0h9.75c3.8,0,6.89,3.09,6.89,6.89v1.79c0,3.8-3.09,6.89-6.89,6.89H.89Zm15.8-1.79c2.82,0,5.11-2.29,5.11-5.11v-1.79c0-2.82-2.29-5.11-5.11-5.11H6.95C4.1,1.79,1.79,4.1,1.79,6.95v6.85h14.91Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7,15.14H.89c-.25,0-.45-.2-.45-.45v-7.74C.45,3.36,3.36.45,6.95.45h9.75c3.55,0,6.45,2.89,6.45,6.45v1.79c0,3.55-2.89,6.45-6.45,6.45Zm-15.36-.89h15.36c3.06,0,5.55-2.49,5.55-5.55v-1.79c0-3.07-2.49-5.55-5.55-5.55H6.95C3.86,1.34,1.34,3.86,1.34,6.95v7.3Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.53,7.82c0,.9-.73,1.62-1.62,1.62s-1.62-.73-1.62-1.62.73-1.62,1.62-1.62,1.62.73,1.62,1.62Z",
    style: {
      fill: "url(#teams-chat_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.73,6.19c-.89,0-1.62.73-1.62,1.62s.73,1.62,1.62,1.62,1.62-.73,1.62-1.62-.73-1.62-1.62-1.62Z",
    style: {
      fill: "url(#teams-chat_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.34,6.19c-.89,0-1.62.73-1.62,1.62s.73,1.62,1.62,1.62,1.62-.73,1.62-1.62-.73-1.62-1.62-1.62Z",
    style: {
      fill: "url(#teams-chat_svg__e)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsChat);
export default __webpack_public_path__ + "static/media/teams-chat.0766d54293802bf5d7d5df6d290c7f67.svg";
export { ForwardRef as ReactComponent };